module.exports = __webpack_public_path__ + "img/Panama.e6576e5a.gif";